import { z } from 'zod';

/**
 * Zod schema for sign-in validation
 */
export const signInSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'El email es requerido')
    .email('Email inválido')
    .max(255, 'Email demasiado largo'),
  password: z
    .string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .max(128, 'Contraseña demasiado larga'),
});

/**
 * Zod schema for sign-up validation with additional full name field
 */
export const signUpSchema = signInSchema.extend({
  fullName: z
    .string()
    .trim()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre es demasiado largo')
    .regex(
      /^[a-zA-ZáéíóúñÁÉÍÓÚÑüÜ\s'-]+$/,
      'El nombre solo puede contener letras, espacios y guiones'
    ),
});

export type SignInData = z.infer<typeof signInSchema>;
export type SignUpData = z.infer<typeof signUpSchema>;

/**
 * Validates sign-in data and returns result with errors
 */
export const validateSignIn = (data: { email: string; password: string }) => {
  return signInSchema.safeParse(data);
};

/**
 * Validates sign-up data and returns result with errors
 */
export const validateSignUp = (data: { email: string; password: string; fullName: string }) => {
  return signUpSchema.safeParse(data);
};

/**
 * Extracts first error message from zod validation result
 */
export const getFirstError = (result: z.SafeParseReturnType<any, any>): string | null => {
  if (result.success) return null;
  const errors = result.error.errors;
  return errors.length > 0 ? errors[0].message : 'Error de validación';
};
